// extracted by mini-css-extract-plugin
export default {"root":"ReviewCount-root-b2D","link":"ReviewCount-link-Q1_"};